import { h, JSX } from 'preact'

export interface IntroSectionProps {
    title?: string
    text?: string
    freeSeats?: {
        label: string
        count: string
    }
}

export const IntroSection = (props: IntroSectionProps): JSX.Element => (
    <div class="checkout__section">
        {props.title && <h2 class="checkout__section-title">{props.title}</h2>}
        {props.text && <div class="checkout__section-text">{props.text}</div>}
        {props.freeSeats && (
            <div class="checkout__section-content">
                <div class="checkout__free-seats-count">
                    {props.freeSeats.label} <strong>{props.freeSeats.count}</strong>
                </div>
            </div>
        )}
    </div>
)
